export enum PotentialSavingsViews {
	RI_SP_TABLE = 'RI_SP_TABLE',
	SAVINGS_GRAPH = 'SAVINGS_GRAPH',
	SP_ALLOCATION = 'SP_ALLOCATION',
	DEEPDIVE_RENEWAL = 'DEEPDIVE_RENEWAL',
	LINUX_UNCOVERED = 'LINUX_UNCOVERED',
	TOTAL_SAVING = 'TOTAL_SAVING',
	LOADING = 'LOADING',
	// EMPTY = 'EMPTY', // not in use
	ERROR = 'ERROR',
	SWITCH_EDP_MODE = 'SWITCH_EDP_MODE',
}
export enum PotentialSavingErrorType {
	MISSING_ACCOUNTS = 'missingAccounts',
	MISSING_PERMISSIONS = 'missingPermissions',
	MISSING_TIME = 'missingTime',
	GENERAL_ERROR = 'generalError',
	SERVER_ERROR = 'error',
}
